import { Component, Input } from "@angular/core";
import { FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { map } from "rxjs";
import { ConfirmationService } from "primeng/api";
import { AddressCountryRegion } from "../../../core/models/client/addclient/countryRegionList";
import { AddressCounty } from "../../../core/models/client/addclient/countyList";
import { AddressState } from "../../../core/models/client/addclient/stateList";
import { CommonModule } from "@angular/common";
import {
  AutoCompleteCompleteEvent,
  AutoCompleteModule,
  AutoCompleteSelectEvent,
} from "primeng/autocomplete";
import { City } from "../../../core/models/client/addclient/cityList";
import { District } from "../../../core/models/vendor/summary/districtList";
import { AddNewClientService } from "../../../core/services/add-new-client.service";
import { AddressService } from "../../../core/services/address.service";
import { DropdownChangeEvent } from "primeng/dropdown";
import { MelissaAddressFormatResponseDto } from "../../../core/models/shared/melissaAddressFromatResponseDto";
import { MelissaAddressResponseDto } from "../../../core/models/shared/mellssaAddressResponseDto";
import { TextareaModule } from "primeng/textarea";
import { InputTextModule } from "primeng/inputtext";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";

@UntilDestroy()
@Component({
  selector: "jni-address",
  templateUrl: "./address.component.html",
  styleUrls: ["./address.component.scss"],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    AutoCompleteModule,
    SelectModule,
    TextareaModule,
    InputTextModule,
    ToggleSwitchModule,
    ButtonModule,
  ],
  providers: [ConfirmationService],
})
export class AddressComponent {
  @Input() parent!: FormGroup;
  @Input() formgroupName!: string;
  @Input() hiddenHeadingStatus = false;
  @Input() appartmentFieldStatus = false;

  @Input() countryRegionList: AddressCountryRegion[] = [];
  @Input() cityList: City[] = [];

  @Input() districtList: District[] = [];
  @Input() countyList: AddressCounty[] = [];
  @Input() stateList: AddressState[] = [];
  @Input() addressFieldStatus!: boolean;
  @Input() isPrimaryFieldStatus = true;
  @Input() showAddress!: boolean;
  @Input() countryRegionSelectedId = "USA";
  @Input() isFromClient = false;
  @Input() isFromAddClient = false;

  public melissa!: MelissaAddressResponseDto;
  formatResponse!: MelissaAddressFormatResponseDto;
  public melissaForNonUsAddress1!: MelissaAddressResponseDto;

  stateSelectedId = "";
  zipSelectionCode = "";

  showZip = true;
  showDistrict = true;
  showPostBox = true;
  showCity = true;
  showCounty = true;
  showState = true;
  showStreetNumber = true;
  showStreet = true;
  showbuildingComplement = true;
  showAppartment = true;

  nonUsandCadFieldStatus = true;
  addressFormatFieldStatus = false;

  showSmallLoader = false;

  addressValidationStatus = true;
  isAddressValidationButton = true;
  isAddressError = false;
  hideValidateButton = true;
  hideNonUsAddressSaveButton = true;

  melissaSelection = "";

  selectedAppartment = "";
  address2 = "";
  address3 = "";
  city = "";
  state = "";
  postalcode = "";

  appartmentList: string[] = [];

  isOpen = false;
  originalAddress = "";

  formErrors: Record<string, string> = {
    nameAliasD365: "",
    partyTypeD365: "",
    customerGroupIdD365: "",
    countryRegionIdD365: "",
    clientFirstNameD365: "",
    clientLastNameD365: "",
    clientPhoneNumberD365: "",
    clientEmailAddressD365: "",
    clientTitle: "",
    invoiceFirstNameD365: "",
    invoiceLastNameD365: "",
    invoicePhoneNumberD365: "",
    invoiceEmailAddressD365: "",
    payableFirstNameD365: "",
    payableLastNameD365: "",
    payablePhoneNumberD365: "",
    payableEmailAddressD365: "",
    billingLocation: "",
    billingAttention: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    nameAliasD365: {
      required: "Client name is required.",
      minlength: "Client name must be greater than 2 characters.",
      maxlength: "Client name must be less than 300 characters.",
    },
    customerGroupIdD365: {
      required: "Client group is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    clientFirstNameD365: {
      pattern: "First name format is not correct.",
    },
    clientLastNameD365: {
      pattern: "Last name format is not correct.",
    },
    clientPhoneNumberD365: {
      pattern: "Phone number must contain 11 digits",
    },
    clientEmailAddressD365: {
      pattern: "Email format is not correct.",
    },
    clientTitle: {
      pattern: "Title format is not correct.",
    },
    invoiceFirstNameD365: {
      pattern: "First name format is not correct.",
    },
    invoiceLastNameD365: {
      pattern: "Last name format is not correct.",
    },
    invoicePhoneNumberD365: {
      pattern: "Phone number must contain 11 digits.",
    },
    invoiceEmailAddressD365: {
      required: "Email is required.",
      pattern: "Email format is not correct.",
    },
    payableFirstNameD365: {
      pattern: "First name format is not correct.",
    },
    payableLastNameD365: {
      pattern: "Last name format is not correct.",
    },
    payablePhoneNumberD365: {
      pattern: "Phone number must contain 11 digits",
    },
    payableEmailAddressD365: {
      pattern: "Email format is not correct.",
    },
    partyTypeD365: {
      required: "Type is required",
    },
    billingLocation: {
      maxlength: "Location must be less than 30 characters.",
    },
    billingAttention: {
      maxlength: "Attention must be less than 30 characters.",
    },
  };

  purposeTypeSelectedId = 1;
  purposeTypes = [
    { name: "Business", value: 1 },
    { name: "Invoice", value: 2 },
    { name: "Payment", value: 3 },
    { name: "Delivery", value: 4 },
    { name: "Other", value: 5 },
    { name: "Buyer", value: 6 },
  ];

  constructor(
    private _addressService: AddressService,
    private confirmationService: ConfirmationService,
    private _addNewClientService: AddNewClientService
  ) {}

  logValidationErrors(group: FormGroup = this.parent): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  onCountryRegionSelection(countryid: string) {
    if (countryid) {
      this.parent.get([this.formgroupName, "zipCodeD365"])?.enable();
      this.parent.get([this.formgroupName, "districtNameD365"])?.enable();
      this.parent.get([this.formgroupName, "cityD365"])?.enable();
      this.parent.get([this.formgroupName, "countyD365"])?.enable();
      this.parent.get([this.formgroupName, "stateD365"])?.enable();
    } else {
      this.parent.get([this.formgroupName, "zipCodeD365"])?.disable();
      this.parent.get([this.formgroupName, "districtNameD365"])?.disable();
      this.parent.get([this.formgroupName, "cityD365"])?.disable();
      this.parent.get([this.formgroupName, "countyD365"])?.disable();
      this.parent.get([this.formgroupName, "stateD365"])?.disable();
    }

    if (countryid) {
      if (
        countryid?.toLowerCase() === "usa" ||
        countryid?.toLowerCase() === "can"
      ) {
        this.nonUsandCadFieldStatus = true;
        this.showAddress = false;
      } else {
        this.nonUsandCadFieldStatus = false;
        this.showAddress = true;
        this.clearNonUsForm();
      }
    }
  }

  getCountyListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getCountyList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countyList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getStateListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getStateList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.stateList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  removeAddressField() {
    this.parent.patchValue({
      [this.formgroupName]: {
        addressD365: "",
      },
    });
    this.melissaSelection = "";
    this.selectedAppartment = "";
  }

  patchValueInMelissaAddressKey() {
    this.parent.patchValue({
      [this.formgroupName]: {
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
  }

  selectedStreet(event: AutoCompleteSelectEvent) {
    const item = event.value;
    if (!item.Address.PostalCode) {
      this.melissaSelection = "";
      return;
    }
    this.removeAddressField();
    this.appartmentList = [];
    this.isOpen = true;
    this._addressService
      .checkAddressValidation(
        item.Address.Address,
        this.countryRegionSelectedId
      )
      .subscribe(x => {
        const formatResponse = x[0];
        this.formatResponse = formatResponse;
        if (formatResponse) {
          if (
            (formatResponse.Results as string)?.toLowerCase()?.includes("av")
          ) {
            this.removeValidationForAddress();
            this.isAddressError = false;
            this.hideValidateButton = true;
            this.removeValidationForAddress();
          } else {
            this.setValidationForAddress();
            this.hideValidateButton = false;
            this.isAddressError = true;
          }
          this.patchValueInMelissaAddressKey();
        }
      });

    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }

    this.melissaSelection = `${item.Address.Address1}\n${item.Address.Address2}\n${item.Address.Address3}`;
    this.parent.patchValue({
      [this.formgroupName]: {
        cityD365: item.Address.Locality,
        stateD365: item.Address.AdministrativeArea,
        streetD365: item.Address.Premise + " " + item.Address.Thoroughfare,
        zipCodeD365: item.Address.PostalCode,
        districtNameD365: item.Address.SubAdministrativeArea,
        postBoxD365: item.Address.PostBox,
        countyD365: item.Address.SubAdministrativeArea,
        // streetNumberD365: item.Address.Premise,
        buildingComplimentD365: item.Address.Building,
        addressD365: `${item.Address.Address1}\n${item.Address.Address2}\n${
          item.Address.Address3
        }${this.selectedAppartment ?? ""}`,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
    // this.ngselect.open();
    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }

    this.formattedAddressChange();
    this._addressService
      .getPostalCodeByZipCode(item.Address.PostalCodePrimary)
      .subscribe(res => {
        this.showSmallLoader = true;
        if (!res.data) {
          this.showSmallLoader = false;
          return;
        }
        this._addressService
          .getCityList(res.data.stateId, res.data.countryRegionId)
          .pipe(
            map(cityResponse => {
              this.cityList = cityResponse.data;

              return cityResponse.data.filter(
                city =>
                  city.cityKeyD365?.includes(res?.data?.cityId) &&
                  city.countryRegionIdD365 == res?.data?.countryRegionId &&
                  city.countyIdD365 == res?.data?.countyId &&
                  city.stateIdD365 == res?.data?.stateId
              );
            })
          )
          .pipe(untilDestroyed(this))
          .subscribe({
            next: () => {
              this.showSmallLoader = false;
            },
            error: () => {
              this.showSmallLoader = false;
            },
          });
      });

    setTimeout(() => {
      if (!item.Address.SubBuilding) {
        this.parent.patchValue({
          [this.formgroupName]: {
            addressFormat: "",
          },
        });
      }
    }, 1);
  }

  patchAddress(item: MelissaAddressFormatResponseDto) {
    if (!item.PostalCode) {
      return;
    }
    this.parent.patchValue({
      [this.formgroupName]: {
        cityD365: item.Locality,
        stateD365: item.AdministrativeArea,
        streetD365: item.PremisesNumber + " " + item.Thoroughfare,
        zipCodeD365: item.PostalCode,
        districtNameD365: item.SubAdministrativeArea,
        postBoxD365: item.PostBox,
        countyD365: item.SubAdministrativeArea,
        // streetNumberD365: item.PremisesNumber,
        buildingComplimentD365: item.SubPremises,
        addressD365: `${item.AddressLine1}\n${item.AddressLine2}\n${item.AddressLine3}`,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
  }

  melissaSearchResult: MelissaAddressResponseDto[] = [];

  searchMelissaAutoComplete(event: AutoCompleteCompleteEvent) {
    if (event.query === "") {
      this.melissaSearchResult = [] as MelissaAddressResponseDto[];
    } else {
      try {
        this._addressService
          .getMelissaData(event.query, this.countryRegionSelectedId)
          .then((x: MelissaAddressResponseDto[]) => {
            this.melissaSearchResult = x;
          });
      } catch {
        this.melissaSearchResult = [] as MelissaAddressResponseDto[];
      }
    }
  }

  melissaFormatter(result: MelissaAddressResponseDto) {
    return result?.Address?.Address;
  }

  onStateSelectionChange(stateid: string) {
    this.parent.patchValue({ [this.formgroupName]: { cityD365: "" } });
    this.getCityListData(stateid, this.countryRegionSelectedId);
  }

  getCityListData(stateid: string, countryid: string) {
    this.showSmallLoader = true;
    this._addressService
      .getCityList(stateid, countryid)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.cityList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  formattedAddressChange() {
    const formattedAddress = this.parent.get([
      this.formgroupName,
      "addressD365",
    ])?.value;
    if (this.melissaSelection != formattedAddress) {
      this.hideValidateButton = false;
      this.setValidationForAddress();
    } else {
      this.hideValidateButton = true;
      this.removeValidationForAddress();
    }
  }

  setValidationForAddress() {
    // this.parent.setErrors({ invalid: true });
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.setValidators(Validators.required);
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.updateValueAndValidity();
  }

  removeValidationForAddress() {
    // this.parent.setErrors({ invalid: false });
    this.parent.get([this.formgroupName, "validateAddress"])?.clearValidators();
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.updateValueAndValidity();
  }

  confirm() {
    this.confirmationService.confirm({
      message: "Are you sure that you want to update address?",
      accept: () => {
        this.validateAddress();
      },
      reject: () => {
        this.parent.patchValue({
          [this.formgroupName]: {
            addressD365: this.melissaSelection,
          },
        });
        this.validateAddress();
      },
    });
  }

  validateAddress(isTypedAddress = false) {
    this.showSmallLoader = true;
    if (isTypedAddress) {
      this.appartmentList = [];
      this.selectedAppartment = "";
    }
    const address = this.parent.get([this.formgroupName, "addressD365"])?.value;

    const country = this.countryRegionSelectedId;

    this._addressService
      .checkAddressValidation(address, country)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: MelissaAddressFormatResponseDto[]) => {
          const item = res[0];
          this.formatResponse = item;
          if (item) {
            this.patchAddress(item);
          }
          this.showSmallLoader = false;
          if (item) {
            if ((item.Results as string)?.toLowerCase()?.includes("av")) {
              this.addressValidationStatus = false;
              this.hideValidateButton = true;
              this.removeValidationForAddress();
              this.isAddressError = false;
            } else {
              this.setValidationForAddress();
              this.hideValidateButton = false;
              this.isAddressError = true;
            }
          }
        },
        error: () => {
          this.showSmallLoader = false;
          this.isAddressError = true;
        },
      });
  }

  onAppartmentSelection(event: DropdownChangeEvent) {
    let value = event.value;
    // this.ngselect.close();
    // const formattedAddress = this.parent.get([
    //   this.formgroupName,
    //   "addressD365",
    // ])?.value;

    if (typeof value === "string") {
      this.parent.patchValue({
        [this.formgroupName]: {
          buildingComplimentD365: value || "",
          addressD365: `${this.melissaSelection}${value || ""}`,
          addressFormat: "",
        },
      });
    } else {
      value = "";
      this.parent.patchValue({
        [this.formgroupName]: {
          buildingComplimentD365: value || "",
          addressD365: `${this.melissaSelection}${value || ""}`,
          addressFormat: "",
        },
      });
    }

    this.validateAddress();
    this.appartmentFieldStatus = true;
  }

  enableAndDisabledValidateButton() {
    const cityD365 = this.parent.get([this.formgroupName, "cityD365"])?.value;
    const stateD365 = this.parent.get([this.formgroupName, "stateD365"])?.value;
    const zipCodeD365 = this.parent.get([
      this.formgroupName,
      "zipCodeD365",
    ])?.value;

    if (cityD365 && stateD365 && zipCodeD365) {
      this.hideNonUsAddressSaveButton = false;
    } else {
      this.hideNonUsAddressSaveButton = true;
      this.clearAddress();
    }
  }

  clearAddress() {
    this.parent.patchValue({
      shipTo: {
        streetD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });
  }

  clearNonUsForm() {
    this.parent.patchValue({
      shipTo: {
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
      },
    });

    this.postalcode = "";
    this.city = "";
    this.state = "";
    this.address2 = "";
    this.address3 = "";
  }

  melissaNonUsSearchResult: MelissaAddressResponseDto[] = [];

  melissaFormatterNonUs(result: MelissaAddressResponseDto) {
    return result?.Address?.Address;
  }

  searchMelissaNonUsAutoComplete(event: AutoCompleteCompleteEvent) {
    if (event.query === "") {
      this.melissaNonUsSearchResult = [] as MelissaAddressResponseDto[];
    } else {
      try {
        this._addressService
          .getMelissaGlobalData(
            event.query,
            this.countryRegionSelectedId,
            this.city,
            this.state,
            this.address2,
            this.address3,
            this.postalcode
          )
          .then((x: MelissaAddressResponseDto[]) => {
            this.melissaNonUsSearchResult = x;
          });
      } catch {
        this.melissaNonUsSearchResult = [] as MelissaAddressResponseDto[];
      }
    }
  }

  patchValueInMak() {
    this.parent.patchValue({
      [this.formgroupName]: {
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
  }

  selectedStreetForNonUs(event: AutoCompleteSelectEvent) {
    const item = event.value;
    if (!item.Address.PostalCode) {
      this.melissaSelection = "";
      return;
    }
    this.removeAddressField();

    this.appartmentList = [];
    this.isOpen = true;
    this._addressService
      .checkAddressValidation(
        item.Address.Address,
        this.countryRegionSelectedId
      )
      .subscribe(x => {
        const formatResponse = x[0];
        this.formatResponse = formatResponse;
        if (formatResponse) {
          if (
            (formatResponse.Results as string)?.toLowerCase()?.includes("av")
          ) {
            this.removeValidationForAddress();
            this.isAddressError = false;
            this.hideValidateButton = true;
            this.removeValidationForAddress();
          } else {
            this.setValidationForAddress();
            this.hideValidateButton = false;
            this.isAddressError = true;
          }
          this.patchValueInMak();
        }
      });

    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }
    this.melissaSelection = `${item.Address.Address1}\n${item.Address.Address2}\n${item.Address.Address3}`;

    this.parent.patchValue({
      [this.formgroupName]: {
        addressLine1: item.Address.Address1,
        addressLine2: item.Address.Address2,
        addressLine3: item.Address.Address3,
        cityD365: item.Address.Locality,
        stateD365: item.Address.AdministrativeArea,
        streetD365: item.Address.Premise + " " + item.Address.Thoroughfare,
        zipCodeD365: item.Address.PostalCode,
        districtNameD365: item.Address.SubAdministrativeArea,
        postBoxD365: item.Address.PostBox,
        countyD365: item.Address.SubAdministrativeArea,
        // streetNumberD365: item.Address.Premise,
        buildingComplimentD365: item.Address.Building,
        addressD365: `${item.Address.Address1}\n${item.Address.Address2}\n${
          item.Address.Address3
        }${this.selectedAppartment || ""}`,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
    // this.ngselect.open();
    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }
    this.formattedAddressChange();
    this._addressService
      .getPostalCodeByZipCode(item.Address.PostalCodePrimary)
      .subscribe(res => {
        this.showSmallLoader = true;
        if (!res.data) {
          this.showSmallLoader = false;
          return;
        }
        this._addressService
          .getCityList(res.data.stateId, res.data.countryRegionId)
          .pipe(
            map(cityResponse => {
              this.cityList = cityResponse.data;

              return cityResponse.data.filter(
                city =>
                  city.cityKeyD365?.includes(res?.data?.cityId) &&
                  city.countryRegionIdD365 == res?.data?.countryRegionId &&
                  city.countyIdD365 == res?.data?.countyId &&
                  city.stateIdD365 == res?.data?.stateId
              );
            })
          )
          .pipe(untilDestroyed(this))
          .subscribe({
            next: () => {
              this.showSmallLoader = false;
            },
            error: () => {
              this.showSmallLoader = false;
            },
          });
      });
  }
}
